
export default {
    name: 'FormSiteButtonGroup',
    props: {
        primary: {
            type: Object,
            default() {
                return null;
            },
        },
        secondary: {
            type: Object,
            default() {
                return null;
            },
        },
    },
};
